webpackJsonp([58415184901741],{

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section describes the application structure.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file represents a configuration that ultimately gets passed to a Model instance of',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-models' },
	        'lore-models'
	      ),
	      '. ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Lore Models'
	      ),
	      ' is the library that Lore uses for making AJAX requests, the interface for which is heavily inspired by',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://backbonejs.org/#Model' },
	        'Backbone.Model'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'All models inherit their properties from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/models.js'
	      ),
	      '. This means that your models themselves will often be empty, especially when you\'re only dealing with a single API that uses consistent conventions. The only time you should edit this file is if you need to set a behavior that is specific to this edit (something that is not shared by the other models). All shared behavior should go in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/models.js'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-src-models-index-js-f58ccddf5dde7f43fd52.js